import React, {Component} from 'react';
import { connect } from "react-redux";
import axios from "axios";
import FormTemplate from "../common/form/FormTemplate";
import { setSelectedControlPanelType, LandNotificationOneAlertsControlPanelKey } from "../../redux/actions/controlPanelActions";

import configData from "../../config/config.json";
import { LOADING_STATUES } from "../constants/constants";
import Confirmation from '../common/modal/Confirmation';
import Loading from '../common/modal/Loading';
import Alert from '../common/modal/Alert';

const componentName = LandNotificationOneAlertsControlPanelKey;

const mapStateToProps = (state) => {
	return {
		multiTenantSettings: state.countyConfigMultiTenantSettingsReducer
	};
}


const matchDispatchToProps = (dispatch) => {
  return { 
    setSelectedControlPanelType: () => dispatch(setSelectedControlPanelType(componentName))
  }
}

class LandNotificationOneAlerts extends Component {

  state = {
    landNotificationOneDbAddress: "",
    landNotificationOneDbName: "",
    landNotificationOneDbUsername: "",
    landNotificationOneDbPassword: "",
    countyCode: "",
    message:"",
    showAlert: false,
    alertMessage: "",
    showMigrateConfirmationDialog: false,
    loadingStatus: "",
    errors: {}
  }

  showAlert = (alertMessage) => {
		this.setState({
		  showAlert: true,
		  alertMessage
		})
	  }
	
	hideAlert = () => {
		this.setState({
			showAlert: false,
			alertMessage: ""
		})
	}

	showLoading = () => {
		if (this.state.status === "") {
			this.setState({
				status: LOADING_STATUES.LOADING
			})
			return true;
		}
		return false;
	}

	handleConfirmMigration = () => {

    if (this.showLoading() === true) {
      axios.post(configData.LANDNOTIFICATION_SERVER_URL + "controlPanel/countyConfig/migrateLandNotificationOneAlerts", this.state, { withCredentials: true })
      .then(
        (response) => {
          this.setState({ 
            status: ''
          }, this.showAlert(response.data.message));
        },
        (error) => {
          this.setState({ 
            status: ''
          });
        }
      );
		}
	}

	showMigrateConfirmation = (event) => {
		event.preventDefault();
		this.setState({
			showMigrateConfirmationDialog: true
		})
	}

	hideMigrateConfirmation = () => {
		this.setState({
      status: '',
			showMigrateConfirmationDialog: false
		})
	}

  handleSubmit = (event) => {
    event.preventDefault();
    this.showMigrateConfirmation(event);
  }

  handleChange = (event) => {
    let value = event.target.value;
    value = value === "true" || value === "false" ? JSON.parse(event.target.value) : value;
    this.setState({
      status: "",
      message: "",
      errors: {},
      [event.target.id]: value ? value : (event.target.type === 'number' ? 0 : value)
    })
  }

  showAlert = (alertMessage) => {
		this.setState({
		  showAlert: true,
		  alertMessage
		})
	  }
	
	hideAlert = () => {
		this.setState({
			showAlert: false,
			alertMessage: ""
		})
	
		if (this.state.redirect) {
			this.props.history.push('/controlPanel/alerts');
		}
	}

  componentDidMount() {
    this.props.setSelectedControlPanelType();
  }

  render() {
  
    const formProps = {
      componentName: componentName,
      pageHeading: "LandNotification One Migration - ALERTS",
      onChange: this.handleChange,
      onSubmit: this.handleSubmit,
      loadingIndicator: this.state.status === LOADING_STATUES.LOADING,
      message: this.state.message,
      formGroupRows: [
        {
          formGroups: [{ id: 'landNotificationOneDbAddress', label: 'LNS1 DB Address (ex. localhost:1234)', fieldType: 'text', required: true, value: this.state.landNotificationOneDbAddress }]
        },
        {
          formGroups: [{ id: 'landNotificationOneDbName', label: 'LNS1 DB Name (ex. LS)', fieldType: 'text', required: true, value: this.state.landNotificationOneDbName }]
        },
        {
          formGroups: [{ id: 'landNotificationOneDbUsername', label: 'LNS1 DB Username', fieldType: 'text', required: true, value: this.state.landNotificationOneDbUsername }]
        },
        {
          formGroups: [{ id: 'landNotificationOneDbPassword', label: 'LNS1 DB Password', fieldType: 'password', required: true, value: this.state.landNotificationOneDbPassword }]
        },
        {
          formGroups: [{ id: 'countyCode', label: 'County Code (ex. SD-FALLRIVER)', fieldType: 'text', required: true, value: this.state.countyCode }]
        }
      ]
    }

    let message = 'Clicking Yes will wipe clean any existing ALERTS and EMAIL ADDRESSES in LNS2.  Continue?' 
    if (this.props.multiTenantSettings.multiTenant === true) {
      message = 'Continue?'
    }

    return (
      <>
        <FormTemplate {...formProps} />
        <Confirmation show={this.state.showMigrateConfirmationDialog} cancelConfirmation={this.hideMigrateConfirmation} proceedConfirmation={this.handleConfirmMigration}  question={message} />
        <Loading loadingIndicator={this.state.status === LOADING_STATUES.LOADING} />
        <Alert show={this.state.showAlert} hideAlert={this.hideAlert} message={this.state.alertMessage} />
      </>
    );
  }
}

export default connect(mapStateToProps, matchDispatchToProps)(LandNotificationOneAlerts);